{
    "name": "masvis-online",
    "version": "1.5.0",
    "type": "module",
    "scripts": {
        "clean": "rm -rf docs/*",
        "start": "vite",
        "build": "npm run clean && vite build",
        "typecheck": "tsc --noEmit",
        "lint": "npm run typecheck && npm run lint:ts && npm run lint:fmt",
        "lint:ts": "oxlint -c oxlint.config.mts --deny-warnings .",
        "lint:fmt": "oxfmt --check .",
        "fix": "npm run fix:ts && npm run fix:fmt",
        "fix:ts": "oxlint -c oxlint.config.mts --fix .",
        "fix:fmt": "oxfmt ."
    },
    "dependencies": {
        "aac": "^0.1.3",
        "alac": "^0.1.0",
        "av": "^0.4.9",
        "bootstrap": "^5.3.8",
        "flac.js": "^0.2.1",
        "mp3": "^0.1.0",
        "owp.feedback": "^1.2.0",
        "owp.get-html-as-image": "^1.1.0",
        "owp.graph-react": "^2.0.0",
        "owp.graph": "^4.0.0",
        "owp.workers": "^1.2.0",
        "prop-types": "^15.8.1",
        "react-bootstrap-icons": "^1.11.6",
        "react-dom": "^19.2.6",
        "react": "^19.2.6"
    },
    "devDependencies": {
        "@types/av": "^0.4.4",
        "@types/node": "25.9.1",
        "@types/react-dom": "^19.2.3",
        "@types/react": "^19.2.15",
        "oxfmt": "^0.51.0",
        "oxlint-tsgolint": "^0.23.0",
        "oxlint": "^1.64.0",
        "tsx": "^4.21.0",
        "typescript": "^6.0.3",
        "vite-plugin-purgecss": "^0.2.13",
        "vite": "^8.0.14"
    }
}
